import {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {API_URL} from "../../URL";
import {getCookie} from "../../hooks/getCookie";

export default function Register() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [isRegister, setIsRegister] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const csrfToken = getCookie("csrftoken");
        const send = await fetch(API_URL + "/register/", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": csrfToken,
            },
            body: JSON.stringify({ email, password }),
        });

        const data = await send.json();

        if (data.detail) {
            setEmail("");
            setPassword("");
            setMessage(data.detail);
        }

        if(data.loggedIn){
            setIsRegister(true);

            setMessage("Registered successfully");
        }
    };

    return (
        <div className="container">
            <div className="forms">
                <form onSubmit={handleSubmit}>
                    <div className="form-title">
                        <p>Register form</p>
                    </div>

                    <div className="form-row">
                        <div className="form">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                className="email input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="form">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                className="password input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        {
                            Boolean(message) && !isRegister && (
                                <div className="form__error">
                                    <p>{message}</p>
                                </div>
                            )
                        }
                        {
                            isRegister && (
                                <div className="form__successfully">
                                    <div className="form__successfully-content">
                                        <span>{message}</span>
                                        <Link to="/login" className="form__login-link">
                                            Go to Login →
                                        </Link>
                                    </div>
                                </div>
                            )
                        }
                        <div className="form">
                            <button className="form__button" type="submit">
                                Register
                            </button>
                        </div>
                    </div>

                    <div className="form-row">
                        <Link to="/login">Sign in</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}